module.exports = __webpack_public_path__ + "static/media/SF-12-A (1).0a5ef742.mp3";